import { useState } from 'react';
import userModel from '../User.model';

const accountFormModel = () => {
  const initialState = {
    id: 0,
    userName: '',
    name: '',
    accountType: '',
    prontoAccountCode: '',
    isItBranchAccount: null,
    company: '',
    nationalAccount: null,
    warehouse: '',
    customerType: '',
    priceLevel: '',
    salesPerson: userModel().initialState,
    territory: '',
    address: {
      id: 0,
      addressLane1: '',
      addressLane2: '',
      suburb: '',
      stateId: {
        id: 0,
        state: '',
      },
      postalCode: '',
      deliveryAddLine1: '',
      deliveryAddLine2: '',
      deliverySuburb: '',
      deliveryStateId: {
        id: 0,
        state: '',
      },
      deliveryPostalCode: '',
    },
    deliveryInstruction: '',
    phoneNumber: '',
    emailAddress: '',
    companyABN: '',
    fullContactName: '',
    industry: '',
    marketingFlag: '',
    deliveryType: '',
    rankOfTheCustomer: '',
    deliverySameAsBilling: true,
    catalogeReqFirstOrder: null,
    chocolatesReqFirstOrder: null,
    addNotes: null,
    invoiceType: '',
    contactPersonForAccountsPayable: null,
    accountPayableContactName: '',
    accountPayableContactNo: '',
    accountPayableEmail: '',
    emailAddressForInvoice: '',
    emailAddressForStatements: '',
    quotesToAddToContract: null,
    salesOrderNo: '',
    addQuotesToFavourites: null,
    onlineAccountRequired: null,
    approvalSystemRequired: null,
    approvalLimit: '',
    approversFullName: '',
    approversEmail: '',
    additionalOnlineUserRequired: null,
    additionalUserName: '',
    additionalUserEmail: '',
    comments: '',
    businessCode: '',
    custNotePad: '',
    noOfStaff: null,
    monthlySpend: null,
    sameAsDelivery: null,
    extensivePricelist: false,
    eductionPricelist: false,
    kitchenJanitorialPriceList: false,
    billToHO: null,
    billToHOAccountCode: '',
  };

  const [accountForm, setAccountForm] = useState(initialState);

  return { accountForm, setAccountForm, initialState };
};

export default accountFormModel;
